import { Pipe, PipeTransform } from '@angular/core'
import { Device } from './../../shared/models'

@Pipe({ name: 'deviceFilter' })
export class DeviceFilterPipe implements PipeTransform {
  public transform (devices: Device[], searchText: string): any[] {
    if (!devices) return []
    if (!searchText) return devices
    searchText = searchText.toLowerCase()
    return devices.filter((it) => {
      return (
        it.name.toLowerCase().includes(searchText) ||
        it.config.licenseId.toLowerCase().includes(searchText)
      )
    })
  }
}
